import customAxios from "./axiosConfig";

const BillingSettingService = {
    list: function (params) {
        var api_url = window.Urls["billingsetting-list"]();
        return customAxios.get(api_url, {params: params});
    },
    changeRecurrency: function (id, data) { // billing settings id data: renewal_months
        var api_url = window.Urls["billingsetting-update-recurrency"](id);
        return customAxios.put(api_url, data);
    },
    retrieveCurrent: function () {
        var api_url = window.Urls['billingsetting-detail'](1); // hardcoded id, wont be used by backend 
        return customAxios.get(api_url);
    },
    cancelPremium: function (reason) {
        var api_url = window.Urls['billingsetting-cancel-premium']();
        return customAxios.get(api_url, {
            params: {
                reason: reason
            }
        });
    },
    uncancelPremium: function () {
        var api_url = window.Urls['billingsetting-uncancel-premium']();
        return customAxios.get(api_url);
    },
    getPaymentMethods: function () {
        var api_url = window.Urls['billingsetting-payment-details']();
        return customAxios.get(api_url);
    },
    addPaymentMethods: function () {
        var api_url = window.Urls['billingsetting-add-payment-details']();
        return customAxios.get(api_url);
    },
    deactivatePaymentMethod: function (data) {
        var api_url = window.Urls['billingsetting_remove_payment_details']();
        return customAxios.post(api_url, data);
    },
    giveFreeMonth: function () {
        var api_url = window.Urls["billingsetting_give_free_month"]();
        return customAxios.get(api_url);
    },
    toggleAddTransactionAsCost: function () {
        var api_url = window.Urls["billingsetting_toggle_add_as_cost"]();
        return customAxios.get(api_url);
    },
    getAvailableTiers: function () {
        var api_url = window.Urls['billingsetting_get_available_tiers']();
        return customAxios.get(api_url);
    },
};
export default BillingSettingService;